import { Vector2 } from "three";
import { HSLColor } from "../../../library-js/colors/HSLColor";
import { HTMLColor } from "../../../library-js/colors/HTMLColor";
import { DOMHitTest } from "../../../library-js/dom-tools/DOMHitTest";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnClick } from "../../../library-js/dom-tools/EventListeners";
import { NodeGraph } from "./NodeGraph";
import { NodeGraphNode } from "./NodeGraphNode";
import { NodeGraphReference } from "./NodeGraphReference";

export class NodeGraphComponent extends NodeGraphReference
{
  static readonly type = new ElementType( "node-component" );

  static readonly inputType = new ElementType( "node-input" );
  static readonly outputType = new ElementType( "node-output" );
  
  static readonly inputConnector = new ElementType( "node-component-input-connector" );
  static readonly outputConnector = new ElementType( "node-component-output-connector" );

  static readonly componentContent = new ElementType( "node-component-content" );
  
  
  _htmlElement:HTMLElement;
  _parent:NodeGraphNode;
  _inputConnector:HTMLElement;
  _outputConnector:HTMLElement;

  _inputConnectorPosition:Vector2 = new Vector2();
  _outputConnectorPosition:Vector2 = new Vector2();

  _inputColor:HTMLColor;
  _outputColor:HTMLColor;

  initilize( parent:NodeGraphNode, htmlElement:Element )
  {
    this._htmlElement = htmlElement as HTMLElement;
    this._parent = parent;
    this.setID( parent._nodeGraph );

    this._inputColor  = new HSLColor( Math.random() * 360, 100, 50 );
    this._outputColor = new HSLColor( Math.random() * 360, 100, 50 );

    this._inputConnector  = NodeGraphComponent.inputConnector.query( this._htmlElement ) as HTMLElement;
    this._outputConnector = NodeGraphComponent.outputConnector.query( this._htmlElement ) as HTMLElement;

    this.setConnectorStyle( this._inputConnector, this._inputColor.toHSL() );
    this.setConnectorStyle( this._outputConnector, this._outputColor.toHSL() );

    NodeGraphReference.attribute.to( this._inputConnector,  this._id );
    NodeGraphReference.attribute.to( this._outputConnector, this._id );
  }

  setConnectorStyle( connector:HTMLElement, color:HSLColor )
  {
    let bg = `linear-gradient(0deg, ${color.clone().multiplyLuminance( 0.3 )}0%, ${color.clone().multiplyLuminance( 0.1 )}100%)`;
    let filter = `drop-shadow(0em 0em 1em ${color+""})`;
    
    connector.style.borderColor = color + "";
    connector.style.background = bg;
    connector.style.filter = filter;

  }

  updateConnectorPositions()
  {
    DOMHitTest.getPageBox( this._inputConnector ).getCenter( this._inputConnectorPosition );
    DOMHitTest.getPageBox( this._outputConnector ).getCenter( this._outputConnectorPosition );

    this._inputConnectorPosition.sub( this._nodeGraph._controller._event.pageOffset );
    this._outputConnectorPosition.sub( this._nodeGraph._controller._event.pageOffset );
  }

}
